import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { initI18n } from "./i18n/index.js";
import { router } from "./router.js";
import { makeInstallable } from "./services/installable.js";
import "./styles/index.css";

const container = document.getElementById("root");
if (!container) {
  // Not an assertion. If the root is missing the page is broken in a way that
  // deserves a message somebody can act on, not a null-deref in React.
  throw new Error("sonolume: #root is missing from index.html");
}

// Awaited before the first render rather than raced with it. The resources are
// bundled (see `i18n/index.ts`), so this resolves on the same tick — nothing is
// fetched — and the alternative is a front door that paints in English and
// flips to Spanish, which reads as a bug rather than as a preference.
await initI18n();

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

// A home-screen icon and no address bar on the one screen every player uses.
// Caches nothing — see `services/installable.ts` for why that is the point.
makeInstallable();
